import { createTheme } from '@mui/material/styles';
import { muiPalette } from './muiPalette';
import { muiTypography } from './muiTypography';
import { muiOverrides } from './muiOverrides';
import { customShadows } from './shadows';
import { sliderOverride, sliderWidths } from './sliderOverride';
import { dateFieldDefaultProps } from './dateFieldOverride';
import { deepmerge } from '@mui/utils';

export const themeSettings = {
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
        'data-qa-id': 'button'
      }
    },
    MuiInputBase: {
      defaultProps: {
        'data-qa-id': 'input-base',
        inputProps: {
          'data-qa-id': 'input'
        }
      }
    },
    MuiMenu: {
      defaultProps: {
        MenuListProps: {
          'data-qa-id': 'menu-list'
        }
      }
    },
    MuiMenuItem: {
      defaultProps: {
        'data-qa-id': 'menu-item'
      }
    },
    MuiPaper: {
      defaultProps: {
        variant: 'outlined'
      }
    },
    MuiSnackbar: {
      defaultProps: {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center'
        }
      }
    },
    MuiRadio: {
      defaultProps: {
        'data-qa-id': 'radio',
        inputProps: {
          'data-qa-id': 'radio-input'
        }
      }
    },
    MuiCheckbox: {
      defaultProps: {
        inputProps: {
          'data-qa-id': 'checkbox'
        }
      }
    },
    MuiSwitch: {
      defaultProps: {
        'data-qa-id': 'switch-button',
        inputProps: {
          'data-qa-id': 'switch-input'
        }
      }
    },
    MuiBadge: {
      defaultProps: {
        'data-qa-id': 'badge'
      }
    },
    MuiAvatar: {
      defaultProps: {
        'data-qa-id': 'avatar'
      }
    },
    MuiSvgIcon: {
      defaultProps: {
        'data-qa-id': 'svg-icon'
      }
    },
    MuiTooltip: {
      defaultProps: {
        'data-qa-id': 'tooltip'
      }
    },
    MuiAlert: {
      defaultProps: {
        'data-qa-id': 'alert',
        slotProps: {
          closeButton: { 'data-qa-id': 'alert-close-button' },
          closeIcon: { 'data-qa-id': 'alert-close-button-icon' }
        }
      }
    },
    MuiAlertTitle: {
      defaultProps: {
        'data-qa-id': 'alert-title'
      }
    },
    MuiDialogActions: {
      defaultProps: {
        'data-qa-id': 'dialog-footer'
      }
    },
    MuiLink: {
      defaultProps: {
        underline: 'hover'
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: 'standard'
      }
    },
    MuiMultiInputDateRangeField: {
      defaultProps: {
        slots: { separator: () => null },
        slotProps: {
          textField: ({ position }) => ({
            variant: 'outlined',
            inputProps: {
              'data-qa-id':
                position === 'start'
                  ? 'date-range-picker__from-input'
                  : 'date-range-picker__to-input'
            }
          })
        }
      }
    },
    ...sliderOverride.props,
    ...dateFieldDefaultProps
  },
  shadows: customShadows,
  ...muiPalette,
  ...muiTypography,
  sizes: {
    chipSelection: {
      small: 28,
      medium: 36
    },
    copyToClipboard: {
      m: 280,
      l: 360,
      xl: 600
    },
    dialog: {
      xs: 444,
      s: 600,
      m: 720,
      l: 960,
      xl: 1280,
      fullWidth: '100%',
      fullScreen: '100%'
    },
    multiSelectMenu: {
      small: 120,
      medium: 280,
      large: 360
    },
    selectMenu: {
      small: 120,
      medium: 280,
      large: 360
    },
    sidePanel: {
      small: 371,
      medium: 406,
      large: 560
    },
    textField: {
      xs: 60,
      s: 120,
      m: 280,
      l: 360,
      xl: 600
    },
    slider: sliderWidths
  }
};

export const commonThemeSettings = deepmerge(themeSettings, muiOverrides);
export const materialTheme = createTheme(themeSettings);
